import singleHomeServer from './home/homeServer';//首页
export {
  singleHomeServer,
}